export default [
    {
        path: 'relatorio-validade-material',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-relatorio-validade-material' */
            '@/views/almoxarifado/relatorio-validade-material/Index'
        ),
        redirect: 'relatorio-validade-material/index',
        children: [
            {
                name: 'almoxarifado-relatorio-validade-material-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-relatorio-validade-material' */
                    '@/views/almoxarifado/relatorio-validade-material/List.vue'
                ),
            },
        ],
    },
]